export const WPPages = {
    Home: ["home"],
    About: ["page-template-about"],
    WebsiteStages: [".hexagon-controls"],
    TestimonialSlider: [".glide-testimonials-about"],
    TestimonialSlider2: [".glide-testimonials-solutions"],
    TestimonialSliderFooter: [".glide-testimonials-footer"],
    MonitorSlider: [".screen-clip-container"],
    CardSlider: [".glide-card-slider"],
 
    isOnHomePage: () => {
      return WPPages.Home.find(
        x => document.body.classList.contains(x)
      );
    },
    isOnAboutPage: () => {
      return WPPages.About.find(
        x => document.body.classList.contains(x)
      );
    },
    hasWebsiteStagesComponent: () => {
      return WPPages.WebsiteStages.find(
        x => document.querySelector(x)
      );
    },
    hasTestimonialSlider: () => {
      return WPPages.TestimonialSlider.find(
        x => document.querySelector(x)
      );
    },
    hasTestimonialSlider2: () => {
      return WPPages.TestimonialSlider2.find(
        x => document.querySelector(x)
      );
    },
    hasTestimonialFooterSlider: () => {
      return WPPages.TestimonialSliderFooter.find(
        x => document.querySelector(x)
      );
    },
    hasMonitorSlider: () => {
      return WPPages.MonitorSlider.find(
        x => document.querySelector(x)
      );
    },
    hasCardSlider: () => {
      return WPPages.CardSlider.find(
        x => document.querySelector(x)
      );
    },
  };
   